import { SuccessFeeOption } from './success-fee-option';

export class NullSuccessFeeOption extends SuccessFeeOption {
	public constructor() {
		super('', undefined, [], false, false);
	}
}
